<template>
  <div class="card">
    <div class="card-header">
      <h5 class="card-title pull-left">Pending Jobs with Blocked Invoices</h5>
      <div class="pull-right">
        <a @click.prevent="resultsToExcel" v-if="this.tableData.length > 0" href="#"><img src="static/img/icon-excel.jpg" title="Export to Excel" style="margin-top:12px;" /></a>
      </div>
    </div>
    <div class="card-body">
      <el-table class="table-striped indexed-table-column-width"
                :data="tableData"
                :max-height="tableHeight(400)"
                border
                style="table-layout:fixed; width:100%;">
        <el-table-column
          :width="indexColumnWidth"
          align="center"
          label="#"
          type="index">
        </el-table-column>
        <el-table-column
          label="Project Name"
          min-width="200">
          <template v-slot="props">
            <div class="no-wrap-ellipsis">{{ props.row.projectName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Department"
          min-width="75">
          <template v-slot="props">
            <div class="no-wrap-ellipsis">{{ props.row.department }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Job Name"
          min-width="200">
          <template v-slot="props">
            <div class="no-wrap-ellipsis">{{ props.row.jobName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Client Name"
          min-width="125">
          <template v-slot="props">
            <div class="no-wrap-ellipsis">{{ props.row.clientName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          class="el-table__fixed"
          fixed="right"
          label="Actions">
          <template v-slot="props">
            <p-button type="success" size="md" icon class="btn-left" title="View Project">
              <span class="invisible">Task ID: {{ props.row.id }}</span>
              <i class="nc-icon nc-ruler-pencil" @click="handleEditProject(props.row.projectId, props.row.jobId)"></i>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="col-sm-12 pagination-info">
        <span class="category">Showing {{total}} entries</span>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from 'src/utilities/constants'
import {getTableHeight, setIndexColumnWidth} from 'src/utilities/utils'
import {createAndDownloadWorksheet} from '@/utilities/excel'
import {OK} from 'http-status-codes'
import _ from 'lodash'

export default {
    data() {
      return {
        tableData: [],
        constants: Constants
      }
    },
    computed: {
      user() {
        return this.$store.get('security/user')
      },
      total() {
        return this.tableData.length
      },
      indexColumnWidth() {
        return setIndexColumnWidth(this.tableData.length)
      }
    },
    methods: {
      tableHeight(buffer) {
        return getTableHeight(buffer)
      },
      async handleEditProject(projectId, jobId) {
        await this.$router.push({path: `/projects/${projectId}?jobId=${jobId}`})
      },
      resultsToExcel() {
        const fileName = 'pending-jobs-with-blocked-invoices.xlsx'
        const tabName = 'Pending Jobs with Blocked Invoices'

        const headerRow = []
        const columnNames = []

        const columns = [
          { sortProp: 'projectId', label: 'Project ID' },
          { sortProp: 'projectName', label: 'Project' },
          { sortProp: 'department', label: 'Department' },
          { sortProp: 'jobId', label: 'Job ID' },
          { sortProp: 'jobName', label: 'Job' },
          { sortProp: 'id', label: 'Task ID' },
          { sortProp: 'name', label: 'Task Name' },
          { sortProp: 'clientName', label: 'Client' },
        ]
        for (const column of columns) {
          columnNames.push({
            key: column.sortProp,
            prop: column.sortProp
          })

          headerRow.push({
            header: column.label,
            key: column.sortProp,
            width: 30
          })
        }

        const rows = []
        this.tableData.forEach((result) => {
          const row = {}
          columnNames.forEach((columnName) => {
            row[columnName.key] = _.get(result, columnName.prop) || null
          })
          rows.push(row)
        })

        createAndDownloadWorksheet(fileName, tabName, headerRow, rows, this.user)
      }
    },
    async beforeMount() {
      const response = await this.$store.dispatch('reportingView/fetchByPendingJobsWithBlockedInvoiceSubmittalTasks')

      if (OK === response.status) {
        this.tableData = response.data
      }
    }
  }
</script>

<style scoped>
  .no-wrap-ellipsis {
    width: 0;
    min-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
